import React from 'react'

import { Route, Switch, Redirect } from 'react-router-dom'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import CreateProducts from './pages/CreateProducts'
import ProductDetails from './pages/ProductDetails'

function App () {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/" render={ () => <Redirect to="/home" /> } />
        <Route exact path="/home" component={ Home } />
        <Route exact path="/login" component={ Login } />
        <Route exact path="/register" component={ Register } />
        <Route exact path="/products" component={ CreateProducts } />
        <Route exact path="/details" component={ ProductDetails } />
      </Switch>
    </div>
  )
}

export default App
